<template>
    <Modal v-model.sync="$api.imgPreview.flag" class='publicModel delModelFoot' width='600px' title="图片预览图">
        <img :src="$api.imgUrl+$api.imgPreview.url" alt="">
    </Modal>
</template>
<script>
    export default {
        data(){
            return {
                flag:this.$api.imgPreview,
            }
        },
        methods:{
        },
    }
</script>


// WEBPACK FOOTER //
// src/common/module/previewImg.vue